:host {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
}

:host([elevated=""]) {
  z-index: 100;
}